import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductList.css';
import PurpleButton from '../common/PurpleButton/PurpleButton';

const ProductList = ({ title, subtitle, products, numberPrefix = "2.1" }) => {
  const navigate = useNavigate();

  const handleCardClick = (index) => {
    navigate(`/products/${products[index].id}`);
  };

  return (
    <section className="product-list container">
      <div className="product-list-header">
        <span className="subtitle">{subtitle}</span>
        <h2>{title}</h2>
      </div>
      <div className="product-grid">
        {products.map((product, index) => (
          <div 
            key={index} 
            className="product-card"
          >
            <div className="product-content">
              <h3>{product.name}</h3>
              <p>{product.shortDesc}</p>
            </div>
            <div className="product-button">
              <PurpleButton 
                text="查看详情" 
                onClick={() => handleCardClick(index)}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductList; 